module.exports = __webpack_public_path__ + "img/loginTop.cdc7b0d6.jpg";